/**
 * Type-safe access of enum records using potentially unsafe input. Ensures
 * you account for the possibility of an undefined key in the record.
 */
export const enumLookup = <T extends string, V>(
  record: Record<T, V>,
  key: T | (string & {}) | number | symbol,
): V | undefined => record[key as T];
